module.exports = __webpack_public_path__ + "media/images/step-4-d268975a5623c57f9ef1e89aeb508d78.png";